import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { completeSeason, createNewSeason, getCurrentSeason, resumeSeason } from "./battleOfTheSchoolsActionAsync";
import { ISeason } from "modules/battleOfSchools/types/BattleOfSchoolsTypes";

export const { actions: battleOfTheSchoolsActions, reducer: battleOfTheSchoolsReducer } = createSlice({
  name: "battleOfTheSchools",
  initialState: {
    season: {
      loadingSeason: false,
      isEndDate: false,
      data: {} as ISeason,
    },
  },
  reducers: {
    setIsEndDateSeason: (state, action: PayloadAction<boolean>) => {
      state.season.isEndDate = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCurrentSeason.pending, (state) => {
        state.season.loadingSeason = true;
      })
      .addCase(getCurrentSeason.fulfilled, (state, action) => {
        state.season.data = action.payload;
        state.season.isEndDate = Boolean(action.payload.EndDateTime);
        state.season.loadingSeason = false;
      })
      .addCase(getCurrentSeason.rejected, (state) => {
        state.season.data = {} as ISeason;
        state.season.loadingSeason = false;
      })
      .addCase(createNewSeason.pending, (state) => {
        state.season.loadingSeason = true;
      })
      .addCase(createNewSeason.fulfilled, (state) => {
        state.season.isEndDate = false;
        state.season.loadingSeason = false;
      })
      .addCase(createNewSeason.rejected, (state) => {
        state.season.loadingSeason = false;
      })
      .addCase(completeSeason.pending, (state) => {
        state.season.loadingSeason = true;
      })
      .addCase(completeSeason.fulfilled, (state) => {
        state.season.isEndDate = true;
        state.season.loadingSeason = false;
      })
      .addCase(completeSeason.rejected, (state) => {
        state.season.loadingSeason = false;
      })
      .addCase(resumeSeason.pending, (state) => {
        state.season.loadingSeason = true;
      })
      .addCase(resumeSeason.fulfilled, (state) => {
        state.season.isEndDate = false;
        state.season.loadingSeason = false;
      })
      .addCase(resumeSeason.rejected, (state) => {
        state.season.loadingSeason = false;
      });
  },
});
